// action constants
import Vue from 'vue'
import { StoreMutations } from './mutations';
import SwiftSpaceRepository from '@/api/SwiftSpaceRepository';

export const StoreActions = {
    get:'get',
    clearState:'clearState'
};

export const actions = {
    get(context,id) {
        SwiftSpaceRepository.getBusiness(id)
        .then((data) => {
            context.commit(StoreMutations.SET_BUSINESS,data.business)
        })
        .catch((err) => {
            Vue.prototype.$notify({'type':'danger','content':err})
        });
    },
    clearState(context) {
        context.commit(StoreMutations.SET_BUSINESS,null);
    }
};
